import KidsTrackingHero from './components/KidsTrackingHero';
import Features from '../../components/sharedComponents/Features';
import HowItWorks from "../../components/sharedComponents/HowItWorks";
import WhyDtp from "../../components/sharedComponents/WhyDtp";
import Testimonials from "../../components/sharedComponents/Testimonials";
import { Helmet } from 'react-helmet';
import { bottomKidsTrackingFeatures } from "./data/bottomKidsTrackingFeatures";
import { kidsTrackingTestimonials } from "./data/kidsTrackingTestimonials";
import { kidsTrackingFeaturesList } from "./data/kidsTrackingFeaturesList";

const KidsTracking = () => {
    return (
        <>
            <Helmet>
                <title>Kids Location Tracking App for Parents - Device Tracker Plus</title>
                <meta name="description" content="Track your child’s location in real time, get instant alerts, and review their history. The smart, non-intrusive tracking app made for parents and kids." />
                <link rel="canonical" href="https://www.devicetrackerplus.com/kids-tracking" />
            </Helmet>
            <KidsTrackingHero />
            <Features sectionTitle="Essential Features for Parents" features={kidsTrackingFeaturesList} />
            <HowItWorks stepOne="Sign up online" stepTwo="Register device" stepThree="Start Tracking" />
            <Testimonials testimonials={kidsTrackingTestimonials} />
            <WhyDtp reasons={bottomKidsTrackingFeatures} title="Why Parents Trust Device Tracker Plus"/>

        </>
    );
}

export default KidsTracking;